<template>
    <v-card flat style="border-top: 1px solid lightgray">
        <v-overlay :value="loadingRuleList">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-expansion-panels v-model="currentPanel">
            <v-expansion-panel
                v-for="(ruleItems, infoProvider, index) in rules"
                :key="infoProvider"
                :style="{
                    background: currentPanel === index ? '#E6E6E6' : '#FFFFFF'
                }"
            >
                <v-expansion-panel-header>
                    <div
                        :style="{
                            'text-decoration': currentPanel === index ? 'underline' : 'none',
                            'font-weight': 'bold'
                        }"
                    >
                        {{ t(capitalizeFirstLetter(infoProvider)) }}
                    </div>
                </v-expansion-panel-header>

                <v-expansion-panel-content
                    :style="{
                        background: currentPanel === index ? '#E6E6E6' : '#FFFFFF'
                    }"
                >
                    <v-data-table
                        :items-per-page="50"
                        :footer-props="footerProps"
                        :search="searchRuleString"
                        class="rules-table"
                        dense
                        :headers="tableHeaders"
                        :items="ruleItems"
                        group-by="related_name_group"
                        group-key="related_name_group"
                        group-desc
                        item-key="id"
                    >
                        <template v-slot:group.header="{ group, headers, toggle, isOpen, item }">
                            <td :colspan="headers.length" class="pl-1 font-weight-bold">
                                <v-btn :ref="group" :data-open="isOpen" icon small @click="toggle">
                                    <v-icon v-if="isOpen">arrow_drop_down</v-icon>
                                    <v-icon v-else>arrow_drop_up</v-icon>
                                </v-btn>
                                {{ group }}
                            </td>
                        </template>

                        <template v-slot:item="{ item }">
                            <tr
                                :key="'rule_' + item.id"
                                @click="handleTableRowClick(item)"
                                :class="{ activeTableRow: activeRule && parseInt(item.id) === parseInt(activeRule.id) }"
                            >
                                <td>{{ item.description ? item.description : "-" }}</td>
                                <td>{{ item.start_date ? item.start_date : "-" }}</td>
                                <td>{{ item.end_date ? item.end_date : "-" }}</td>
                                <td>{{ item.related_export_client_name || "-" }}</td>
                                <td>{{ item.related_client_name || "-" }}</td>
                                <td>{{ item.related_store_name || "-" }}</td>
                                <td>{{ item.related_tag_name || "-" }}</td>
                                <td style="text-align: right">
                                    {{ item.percent ? `${item.percent.toFixed(0)}%` : "-" }}
                                </td>
                                <td style="text-align: right">
                                    {{
                                        item.amount !== null
                                            ? item.amount % 1 !== 0
                                                ? item.amount.toFixed(2)
                                                : item.amount.toFixed(0)
                                            : "-"
                                    }}
                                </td>

                                <td style="text-align: right">
                                    {{ item.entry_type ? capitalizeFirstLetter(item.entry_type) : "-" }}
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { helperMixin } from "@/mixins/helper-mixin";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "rule-list",
    data() {
        return {
            currentPanel: 0,
            footerProps: { "items-per-page-options": [25, 50, 100] },
            tableHeaders: [
                {
                    text: this.t("Description"),
                    align: "left",
                    value: "description"
                },
                {
                    text: this.t("Start date"),
                    align: "left",
                    value: "start_date"
                },
                {
                    text: this.t("End date"),
                    align: "left",
                    value: "end_date"
                },
                {
                    text: this.t("Export client"),
                    align: "left",
                    value: "related_export_client_name"
                },
                {
                    text: this.t("Client"),
                    align: "left",
                    value: "related_client_name"
                },
                {
                    text: this.t("Store"),
                    align: "left",
                    value: "related_store_name"
                },
                {
                    text: this.t("Tag"),
                    align: "left",
                    value: "related_tag_name"
                },
                {
                    text: this.t("Percent"),
                    align: "right",
                    value: "percent"
                },
                {
                    text: this.t("Sum"),
                    align: "right",
                    value: "amount"
                },
                {
                    text: this.t("Entry type"),
                    align: "right",
                    value: "entry_type"
                }
            ]
        };
    },
    async mounted() {
        await this.getRuleList();
    },
    mixins: [helperMixin],
    computed: {
        ...mapState("RuleStore", ["rules", "loadingRuleList", "activeRule", "searchRuleString"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    methods: {
        ...mapActions("RuleStore", ["getRuleData", "getRuleList"]),
        handleTableRowClick(rule) {
            if (!this.hasPermissionForAction(PermissionsConstants.RULES, PermissionsConstants.VIEW)) {
                return;
            }
            if (this.$route.name !== "rule-view") {
                this.$router.push({ name: "rule-view", params: { ruleId: rule.id } });

                return;
            }
            if (this.$route.name === "rule-view" && parseInt(rule.id) !== parseInt(this.$route.params.ruleId)) {
                this.$router.push({ name: "rule-view", params: { ruleId: rule.id } });
                this.getRuleData(rule.id);
            }
        }
    }
};
</script>

<style scoped>
.activeTableRow {
    background-color: #f41823;
    color: #fff;
}

.activeTableRow:hover {
    background-color: #e11520 !important;
    color: #fff !important;
}

.v-data-table-header {
    background-color: #f0f0f0;
}
::v-deep .v-data-table-header th {
    white-space: nowrap;
}
td {
    height: 25px !important;
}
</style>
